import {
  Divider,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'
import GraficoEstoque from './GraficoEstoque'
import GraficoMovimentacao from './GraficoMovimentacao'
import GraficoTopSaida from './GraficoTopSaida'
import GraficoTopProdutoQuantidade from './GraficoTopProdutoQuantidade'
import { metodoPrograma } from '../../../components/api'

const MovimentoEstoque = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [indicador, setIndicador] = useState({})
  const [dados, setDados] = useState(null)
  const [setDadosItem] = useState(null)

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const getIndicadores = useCallback(() => {
    metodoPrograma('getIndicadores', {}).then((res) => {
      if (res.status) {
        setIndicador(res)
      }
    })
  }, [])

  useEffect(() => {
    getIndicadores()
  }, [getIndicadores])

  return (
    <Programa codigo="CtrlMovimentoEstoque" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
            <Paper
              elevation={0}
              style={{
                backgroundColor: '#f5f5f5', // cinza bem claro
                borderRadius: '12px', // bordas arredondadas
                padding: '16px',
              }}
            >
              <Typography
                variant="h7"
                style={{ marginBottom: '10px', fontWeight: 500 }}
              >
                Situação Geral do Estoque
              </Typography>
              <Divider style={{ marginBottom: 15 }} />
              <GraficoEstoque indicador={indicador} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
            <Paper
              elevation={0}
              style={{
                backgroundColor: '#f5f5f5', // cinza bem claro
                borderRadius: '12px', // bordas arredondadas
                padding: '16px',
              }}
            >
              <Typography
                variant="h7"
                style={{ marginBottom: '10px', fontWeight: 500 }}
              >
                Movimentações
              </Typography>
              <Divider style={{ marginBottom: 15 }} />
              <GraficoMovimentacao indicador={indicador} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
            <Paper
              elevation={0}
              style={{
                backgroundColor: '#f5f5f5', // cinza bem claro
                borderRadius: '12px', // bordas arredondadas
                padding: '16px',
              }}
            >
              <Typography
                variant="h7"
                style={{ marginBottom: '10px', fontWeight: 500 }}
              >
                Top 5 maior saída por quantidade
              </Typography>
              <Divider style={{ marginBottom: 15 }} />
              {indicador.topMaiorSaida && (
                <GraficoTopSaida indicador={indicador} />
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
            <Paper
              elevation={0}
              style={{
                backgroundColor: '#f5f5f5', // cinza bem claro
                borderRadius: '12px', // bordas arredondadas
                padding: '16px',
              }}
            >
              <Typography
                variant="h7"
                style={{ marginBottom: '10px', fontWeight: 500 }}
              >
                Top 5 maior estoque
              </Typography>
              <Divider style={{ marginBottom: 15 }} />

              {indicador.topMaiorEstoque && (
                <GraficoTopProdutoQuantidade indicador={indicador} />
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 20 }}>
            <PrimeTable
              title="Movimentações"
              codigo="CtrlMovimentoEstoque"
              action="lista"
              rows={10}
              habSearch
              colStyle={[{ width: '40%' }]}
              collumnsDateHour={[2]}
              collumnsCurrency={[6]}
              head={[
                'Nome',
                'Código',
                'Data',
                'Quantidade',
                'Saldo',
                'Estoque Mínimo',
                'Valor',
              ]}
              line={(item) => [
                item[0][1],
                item[1],
                item[3],
                item[4],
                item[5],
                item[6],
                item[7],
              ]}
              parametros={{ teste: true }}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela, setDadosItem }} />
      )}
    </Programa>
  )
}

export default MovimentoEstoque
